import HeroBackgroundPage from '@/components/templates/HeroBackgroundPage';
import {
  CREATOR_APPLICATION_BACKGROUND,
  CREATOR_APPLICATION_BACKGROUND_OPACITY,
} from '@/constants/creatorApplication';
import CreatorApplicationProfilePreview from '@/modules/contentCreator/CreatorApplicationProfilePreview';
import { useCreatorApplicationStore } from '@/store/useCreatorApplicationStore';
import { createFileRoute, redirect } from '@tanstack/react-router';

const ProfilePreviewPage = () => {
  const previewData = useCreatorApplicationStore((state) => state.previewData);

  return (
    <HeroBackgroundPage
      heroChildren={previewData ? <CreatorApplicationProfilePreview data={previewData} /> : null}
      backgroundOverlay={CREATOR_APPLICATION_BACKGROUND}
      backgroundOverlayOpacity={CREATOR_APPLICATION_BACKGROUND_OPACITY}
      isBackgroundFixed
    />
  );
};

export const Route = createFileRoute('/creator/apply/preview/')({
  staticData: { title: 'Application Preview' },
  component: ProfilePreviewPage,
  beforeLoad: () => {
    if (!useCreatorApplicationStore.getState().previewData) {
      throw redirect({ to: '/creator/apply/form' });
    }
  },
});
